import { useState } from "react";
import Button from "../../../Custom/Button/Button";
import styles from "./styles";
import CustomCalendarInput from "./CustomCalendarInput";
import axios from "axios";
import { useGlobalContext } from "../../../../Context/Context";

const nowDate = new Date()
  .toLocaleDateString("sr-RS", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })
  .replaceAll("/", ".")
  .slice(0, -1);

const natpis = { fontWeight: "bold", fontSize: "14px", marginBottom: "5px" };
const inputStyle = {
  fontSize: "14px",
  height: "40px",
  padding: "0 8px",
  width: "100%",
  boxSizing: "border-box",
};

const formatDateForApi = (dateStr) => {
  if (!dateStr) return null;
  const parts = dateStr.replace(/\.$/, "").split(".");
  if (parts.length < 3) return null;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
};

function EvidencijeObrazac10Dodavanje({ setIsDodavanje, onRefresh }) {
  const [obrazac, setObrazac] = useState({
    predmet_ispitivanja: "",
    broj_mernih_mesta: "",
    broj_nalaza: "",
    datum_ispitivanja: nowDate,
    datum_sledeceg: "",
    napomena: "",
  });

  const { baseUrl, selectedMainEntity } = useGlobalContext();

  const handleChange = (newValue, field) => {
    setObrazac((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleSacuvaj = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija10/create.php`, {
        company_id: selectedMainEntity.company_id,
        predmet_ispitivanja: obrazac.predmet_ispitivanja,
        broj_mernih_mesta: obrazac.broj_mernih_mesta,
        broj_nalaza: obrazac.broj_nalaza,
        datum_ispitivanja: formatDateForApi(obrazac.datum_ispitivanja),
        datum_sledeceg: formatDateForApi(obrazac.datum_sledeceg),
        napomena: obrazac.napomena,
      });
      if (data.status === 200) {
        onRefresh();
        setIsDodavanje(false);
      }
    } catch (e) {
      console.error("Greška:", e);
    }
  };

  const isDisabledSacuvaj =
    !obrazac.predmet_ispitivanja ||
    !obrazac.broj_nalaza ||
    !obrazac.datum_sledeceg;

  return (
    <div style={{ marginTop: "15px" }}>
      <div
        style={{
          display: "flex",
          gap: "10px",
          alignItems: "flex-end",
          justifyContent: "space-between",
        }}
      >
        <div style={{ width: "15vw" }}>
          <div style={natpis}>ПРЕДМЕТ ИСПИТИВАЊА</div>
          <input
            value={obrazac.predmet_ispitivanja}
            onChange={(e) =>
              handleChange(e.target.value, "predmet_ispitivanja")
            }
            style={inputStyle}
          />
        </div>

        <div style={{ width: "5vw" }}>
          <div style={natpis}>БР. МЕСТА</div>
          <input
            type="number"
            value={obrazac.broj_mernih_mesta}
            onChange={(e) => handleChange(e.target.value, "broj_mernih_mesta")}
            style={inputStyle}
          />
        </div>

        <div style={{ width: "12vw" }}>
          <div style={natpis}>БРОЈ НАЛАЗА</div>
          <input
            value={obrazac.broj_nalaza}
            onChange={(e) => handleChange(e.target.value, "broj_nalaza")}
            style={inputStyle}
          />
        </div>

        <div>
          <div style={natpis}>ИЗВРШЕНО</div>
          <CustomCalendarInput
            value={obrazac.datum_ispitivanja}
            onChange={(v) => handleChange(v, "datum_ispitivanja")}
          />
        </div>

        <div>
          <div style={natpis}>СЛЕДЕЋЕ</div>
          <CustomCalendarInput
            value={obrazac.datum_sledeceg}
            onChange={(v) => handleChange(v, "datum_sledeceg")}
          />
        </div>

        <div style={{ width: "15vw" }}>
          <div style={natpis}>НАПОМЕНА</div>
          <input
            value={obrazac.napomena}
            onChange={(e) => handleChange(e.target.value, "napomena")}
            style={inputStyle}
          />
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <div onClick={() => setIsDodavanje(false)}>
            <Button activation={true} style={styles.button}>
              ОДУСТАНИ
            </Button>
          </div>
          <div
            onClick={isDisabledSacuvaj ? undefined : handleSacuvaj}
            style={{ opacity: isDisabledSacuvaj ? 0.5 : 1 }}
          >
            <Button
              isDisabled={isDisabledSacuvaj}
              activation={true}
              style={styles.button}
            >
              САЧУВАЈ
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EvidencijeObrazac10Dodavanje;
